import React from "react";
import {
  AIAssistantButton as SharedAIAssistantButton,
  ClassificationEngineDialog as SharedClassificationEngineDialog,
} from "../../Common/ClassificationEngine/ClassificationEngine";
import { classifyData } from "../../../contexts/services/ai-assistant/aiAssistantServices";
import ColumnSelectionReviewStep from "./ColumnSelectionReviewStep";
import ReviewSyncStep, { unwrapClassifyResponse } from "./ReviewSyncStep";
import detailPLClassificationConfig from "./classificationConfig";

const classifyAccounts = async (rows, options) =>
  unwrapClassifyResponse(await classifyData(rows, options));

const getWorkflowProps = ({
  companyType,
  currency,
  existingSectionCounts = {},
  existingTaggedCount = 0,
  ...props
}) => ({
  ...detailPLClassificationConfig,
  ...props,
  ColumnSelectionStep: ColumnSelectionReviewStep,
  ReviewStep: ReviewSyncStep,
  classify: classifyAccounts,
  columnSelectionProps: { companyType },
  reviewProps: {
    companyType,
    currency,
    existingSectionCounts,
    existingTaggedCount,
  },
});

const ClassificationEngineDialog = (props) => (
  <SharedClassificationEngineDialog {...getWorkflowProps(props)} />
);

const AIAssistantButton = (props) => (
  <SharedAIAssistantButton {...getWorkflowProps(props)} />
);

export { AIAssistantButton, ClassificationEngineDialog };
export default AIAssistantButton;
